var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicalSummary1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1262",
    "data-name": "Group 1262",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.643,
    height: 25.319,
    viewBox: "0 0 22.643 25.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 22.643,
    height: 25.319,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1261",
    "data-name": "Group 1261",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M31.185,23.564V6.369a1.135,1.135,0,0,0-.359-.852c-1.191-1.184-2.4-2.392-3.567-3.56L25.848.546c-.109-.107-.218-.212-.327-.313L25.373.092,25.278,0H10.861l-.051.019a1.789,1.789,0,0,0-1.227,1.9c.011,4.388.011,6.718.011,11.032V17.28a1.328,1.328,0,0,0,.013.276.742.742,0,0,0,1.468,0,1.328,1.328,0,0,0,.013-.276V1.772a.725.725,0,0,1,.026-.25A.717.717,0,0,1,11.36,1.5H24.246V5.309c0,.03,0,.061,0,.091a1.583,1.583,0,0,0,1.629,1.536h2.356l.069,0a.764.764,0,0,0,.783-.745.72.72,0,0,0-.13-.431l.644.641a.26.26,0,0,1,.094.218V23.511a.9.9,0,0,1-.026.284.915.915,0,0,1-.291.026h-17.8a.745.745,0,0,0,.057,1.489H29.431a1.591,1.591,0,0,0,1.753-1.746M28.235,5.439H25.959a.514.514,0,0,1-.2-.024.424.424,0,0,1-.026-.2V2.544c1,1.006,2.032,2.035,3.055,3.055a.931.931,0,0,0-.554-.16",
    transform: "translate(-8.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M11.571,53.5A6.1,6.1,0,0,0,8.033,54.62,6.032,6.032,0,0,0,5.56,58.2a6.155,6.155,0,0,0,1.29,5.546l-.2.2c-.254.251-.5.488-.735.736-.049.05-.066.05-.075.05a.216.216,0,0,1-.075-.021,1.724,1.724,0,0,0-.662-.142A1.421,1.421,0,0,0,4.084,65C2.963,66.1,1.771,67.295.437,68.65A1.456,1.456,0,0,0,.091,70.2a1.523,1.523,0,0,0,1.47,1.081,1.648,1.648,0,0,0,1.16-.491c.7-.7,1.418-1.412,2.107-2.1q.674-.677,1.351-1.352a1.583,1.583,0,0,0,.388-1.862.1.1,0,0,1,0-.034c.279-.285.559-.564.838-.844l.14-.14a6.11,6.11,0,0,0,3.993,1.469,6.331,6.331,0,0,0,4.791-2.2A6.214,6.214,0,0,0,11.571,53.5M1.061,69.949a.528.528,0,0,1,.093-.615c.125-.138.261-.271.393-.4l.168-.166.82-.821c.713-.713,1.45-1.451,2.177-2.174a.651.651,0,0,1,.455-.2h0a.55.55,0,0,1,.544.437.523.523,0,0,1-.142.526c-1.212,1.218-2.4,2.408-3.6,3.591a.767.767,0,0,1-.252.138l-.066.027a.605.605,0,0,1-.59-.344m10.514-5.018H11.56A5.217,5.217,0,0,1,11.578,54.5h.006a5.217,5.217,0,1,1-.008,10.435",
    transform: "translate(0 -47.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M71.407,108.088a.63.63,0,0,0,.149-.015.493.493,0,0,0,0-.967.652.652,0,0,0-.146-.014H64.369a.669.669,0,0,0-.122.01.493.493,0,0,0,0,.978.668.668,0,0,0,.121.009h7.039Z",
    transform: "translate(-57.017 -95.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M81.172,123.853a.667.667,0,0,0-.12-.009H74.368a.658.658,0,0,0-.121.009.493.493,0,0,0,0,.978.666.666,0,0,0,.121.009H81.05a.649.649,0,0,0,.122-.01.493.493,0,0,0,0-.978",
    transform: "translate(-65.951 -110.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M74.361,91.362h4.923c.168,0,.3,0,.425,0a.443.443,0,0,0,.471-.4.685.685,0,0,0-.17-.47.553.553,0,0,0-.414-.122H74.341a.493.493,0,0,0-.49.495s0,.006,0,.009a.5.5,0,0,0,.51.488",
    transform: "translate(-65.978 -80.734)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicalSummary1);
export default __webpack_public_path__ + "static/media/clinical-summary1.3fac294ba7f8d742428027511f644ec3.svg";
export { ForwardRef as ReactComponent };